import { Button } from '@seddi/ui-kit';
import type { FC } from 'react';
import styled from 'styled-components';

import { decoratorGradient } from '@/styles/theme';

import BackgroundImage from '@/static/images/background_image.webp';
import DecoratorLogo from '@/static/images/seddi_decorator.svg';

const Wrapper = styled.div`
  align-items: center;
  background-image: url(${BackgroundImage});
  background-size: cover;
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
  text-align: center;

  &::before {
    background: ${decoratorGradient};
    content: '';
    inset: 0;
    opacity: 0.85;
    position: absolute;
  }
`;

const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
  z-index: 1;
`;

const Logo = styled.img`
  height: 48px;
`;

const Title = styled.h1`
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
`;

const Message = styled.p`
  color: #fff;
  margin: 0;
  max-width: 480px;
  opacity: 0.9;
`;

type AppErrorFallbackProps = {
  error: Error;
  resetError: () => void;
};

export const AppErrorFallback: FC<AppErrorFallbackProps> = ({ error, resetError }) => {
  return (
    <Wrapper>
      <Content>
        <Logo alt="Decorator" src={DecoratorLogo as unknown as string} />
        <Title>Something went wrong</Title>
        <Message>{error.message || 'An unexpected error occurred. Please try again.'}</Message>
        <Button onClick={resetError} text="Try again" />
      </Content>
    </Wrapper>
  );
};
